// Horizontal page gutter for reader pages: 24px on phones, growing with the
// viewport so content stays centred on wide screens. See docs/RESPONSIVE.md.
const PaddingX = ({ side, className = "", children }) => {
	let padding;
	switch (side) {
		case "left":
			padding = "ml-4 lg:ml-10 xl:ml-28 2xl:ml-72";
			break;
		case "right":
			padding = "mr-4 lg:mr-10 xl:mr-28 2xl:mr-72";
			break;
		default:
			padding = "mx-4 lg:mx-10 xl:mx-28 2xl:mx-72";
			break;
	}
	return <div className={`px-2 min-w-0 ${padding} ${className}`.trim()}>{children}</div>;
};

export default PaddingX;
